import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import { Stack } from "Signups/FamilyRegistration/Shared/StyledComponents";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";
import { motion } from "framer-motion";

import { FnrScreen } from "UI/FnrScreens";

import FundItMarketingBlurb from "./Settings/FundItMarketingBlurb";
import ReceiveGivingEnvelopes from "./Settings/ReceiveGivingEnvelopes";
import RecurringGifts from "./Settings/RecurringGifts";

export default function GivingPanel() {
  const {
    state: { selectedPanel },
  } = useFamilyRegistrationContext();

  const { shouldShowFundItBlurb } = useFamilyRegistrationAdminPermissions();

  // const showFundItBlurb =
  //   userCanViewFamilyRegistrationPanel && networkHasFNC && !networkHasFundIt;

  return (
    <FnrScreen
      show={selectedPanel === "giving"}
      side={selectedPanel === "finishing-up" ? "left" : "right"}
    >
      {shouldShowFundItBlurb && <FundItMarketingBlurb />}
      <Stack gap={48}>
        <RecurringGifts />
        <ReceiveGivingEnvelopes />
      </Stack>
    </FnrScreen>
  );

  // return (
  //   <motion.div
  //     initial={{ opacity: 0 }}
  //     animate={{ opacity: 1 }}
  //     exit={{ opacity: 1 }}
  //   >
  //     {showFundItBlurb ? (
  //       <FundItMarketingBlurb />
  //     ) : (
  //       <Stack gap={48}>
  //         <RecurringGifts />
  //         <ReceiveGivingEnvelopes />
  //       </Stack>
  //     )}
  //   </motion.div>
  // );
}
